// extracted by mini-css-extract-plugin
module.exports = {"content":"Modal_content___w8R9"};